import { format } from "@web-monorepo/dates";
import TodayEdit, { TodayEditProps } from "./TodayEdit";
import TodayResult from "./TodayResult";
import { appMetadataToday, RECEIVE_NOTES } from "src/pods/today";
import { Tool, ToolPayload } from "src/pods/toolkitData/components/EditableSetup";
import EditableToolContainer from "src/pods/toolkitData/components/EditableToolContainer";
import SavedToolButton from "src/pods/toolkitData/components/SavedToolButton";
import { useToolkitSession } from "src/pods/auth/useToolkitSession";

type TodaySetupContainerProps = {
  params: {
    classId: string;
  };
  onEdit: (tool: ToolPayload, disabled?: boolean) => void;
  payload: ToolPayload;
};

function titleCase(arg: string): string {
  return arg.replace(/(\s|^)([\w])/g, (_m, s, l) => `${s}${l.toLocaleUpperCase()}`);
}

export default function TodaySetupContainer(props: TodaySetupContainerProps) {
  const { user } = useToolkitSession();
  const locale = user?.locale ?? "";

  const title = titleCase(
    format(new Date(), {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      locale,
    }),
  );

  return (
    <EditableToolContainer
      toolType="today"
      title={title}
      appMetadata={appMetadataToday()}
      {...props}
      renderItem={({
        tool,
        openEditScreen,
        showTool,
      }: {
        tool: Tool;
        openEditScreen: (tool: Tool) => void;
        showTool: (tool: Tool) => void;
      }) => (
        <SavedToolButton
          data-name={`today_setup_container:saved_tool_button:${tool._id || tool.dojoId}`}
          key={tool._id || tool.dojoId}
          onRowClick={() => showTool(tool)}
          onEditClick={tool.dojoId ? null : () => openEditScreen(tool)}
          buttonText={tool.payload.text}
        >
          {tool.payload.text}
        </SavedToolButton>
      )}
      renderEditItem={(props: TodayEditProps) => <TodayEdit onEdit={props.onEdit} payload={props.payload} />}
      renderResult={({ tool }: { tool: Tool }) => <TodayResult title={title} text={tool.text} />}
      getDisplayPayload={(tool: Tool) => ({
        type: RECEIVE_NOTES,
        payload: { title, text: tool.text },
      })}
    />
  );
}
